import React, { FC, PropsWithChildren } from "react";
import { BotConfigurationType, BotType } from "@shared/types";
import { BotFormType } from "@shared/features/bots/BotForm/common/types";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import useBotFormProvider from "@shared/features/bots/BotForm/useBotFormProvider";
import AdditionalBotValuesProvider from "@shared/features/bots/BotForm/common/AdditionalBotValuesProvider";

interface BotFormProviderProps {
  botID?: number;
  botUUID?: string;
  botIDs?: number[];
  botType: BotType;
  botFormType: BotFormType;
  isChannelConfiguration?: boolean;
  isMobileApp?: boolean;
  isLoading?: boolean;
  isBacktesting?: boolean;
  backtestingBotId?: number;
  isCopyToWorkspace?: boolean;
  isDemoCopyPublic?: boolean;
  configurationType?: BotConfigurationType;
  subGroupId?: number;
  loadingEndDelayMs?: number;
}

const BotFormProvider: FC<PropsWithChildren<BotFormProviderProps>> = ({
  children,
  botID,
  botUUID,
  botIDs,
  botType,
  botFormType,
  isChannelConfiguration,
  isMobileApp,
  isLoading: propsIsLoading,
  isBacktesting,
  backtestingBotId,
  isCopyToWorkspace,
  isDemoCopyPublic,
  configurationType,
  subGroupId,
  loadingEndDelayMs,
}) => {
  const { formData, getParsedFormData, botGeneralData } = useBotFormProvider({
    botID,
    backtestingBotId,
    botIDs,
    botUUID,
    botType,
    botFormType,
    isChannelConfiguration,
    isMobileApp,
    isBacktesting,
    isDemoCopyPublic,
    isCopyToWorkspace,
    configurationType,
    subGroupId,
    loadingEndDelayMs,
  });
  const isLoading = propsIsLoading || formData.isLoading;

  return (
    <BotFormContext.Provider
      value={{
        botGeneralData: botGeneralData as any,
        getParsedFormData,
        isEdit: !!(botID || botUUID),
        isPublic: botFormType === BotFormType.COPY_PUBLIC,
        isDuplicate: botFormType === BotFormType.DUPLICATE,
        botType,
        botFormType,
        isChannelConfiguration,
        ...formData,
        isLoading,
        isBacktesting,
        isCopyToWorkspace,
        configurationType,
        subGroupId,
        botUUID,
      }}
    >
      <AdditionalBotValuesProvider>{children}</AdditionalBotValuesProvider>
    </BotFormContext.Provider>
  );
};

export default BotFormProvider;
